module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-19-202c1980a7faee862b858c2def6b74c1.jpg";